export const deTranslations = {
  nav: {},
};
